export const LEGACY_TRACK_TITLE_ICONS = Object.freeze([
  Object.freeze({key: "sold", icon: "★", aliases: Object.freeze(["★"]), label: "Sold", meaning: "Sold / unavailable"}),
  Object.freeze({key: "original", icon: "🔥", aliases: Object.freeze(["🔥"]), label: "Original", meaning: "Original / exclusive unavailable"}),
  Object.freeze({key: "remix", icon: "❤️", aliases: Object.freeze(["❤️", "❤"]), label: "Remix", meaning: "Remix / unavailable"}),
  Object.freeze({key: "halfOff", icon: "$", aliases: Object.freeze(["$"]), label: "Half-off", meaning: "Half-off promotion"}),
  Object.freeze({key: "freeLease", icon: "🛒", aliases: Object.freeze(["🛒"]), label: "Free lease", meaning: "Free lease promotion"}),
  Object.freeze({key: "special", icon: "🌿", aliases: Object.freeze(["🌿"]), label: "Special", meaning: "Special catalog marker"}),
]);

const ALIAS_TO_ITEM = new Map(LEGACY_TRACK_TITLE_ICONS.flatMap((item) => item.aliases.map((alias) => [alias, item])));
const orderedAliases = [...ALIAS_TO_ITEM.keys()].sort((a, b) => b.length - a.length);

export const NO_TITLE_DECORATION = Object.freeze({enabled: false, icon: null, position: "before"});

export function normalizeTitleDecoration(value) {
  if (!value || value.enabled !== true) return {...NO_TITLE_DECORATION};
  const item = ALIAS_TO_ITEM.get(String(value.icon || ""));
  if (!item) return {...NO_TITLE_DECORATION};
  return {enabled: true, icon: item.icon, position: value.position === "after" ? "after" : "before"};
}

export function detectLegacyTitleDecoration(value) {
  const original = String(value || "").trim();
  for (const alias of orderedAliases) {
    if (original.startsWith(alias)) {
      const item = ALIAS_TO_ITEM.get(alias);
      return {matched: true, title: original.slice(alias.length).trimStart(), decoration: {enabled: true, icon: item.icon, position: "before"}, legacyIcon: alias};
    }
    if (original.endsWith(alias)) {
      const item = ALIAS_TO_ITEM.get(alias);
      return {matched: true, title: original.slice(0, -alias.length).trimEnd(), decoration: {enabled: true, icon: item.icon, position: "after"}, legacyIcon: alias};
    }
  }
  return {matched: false, title: original, decoration: {...NO_TITLE_DECORATION}, legacyIcon: null};
}

export function canonicalTrackTitle(trackOrTitle) {
  const title = typeof trackOrTitle === "object" && trackOrTitle !== null ? trackOrTitle.title : trackOrTitle;
  let canonical = String(title || "").trim().replace(/\s+/g, " ");
  // A title may contain more than one old boundary marker. Only registry values
  // are removed; user-authored emoji and punctuation remain untouched.
  for (let i = 0; i < LEGACY_TRACK_TITLE_ICONS.length; i += 1) {
    const detected = detectLegacyTitleDecoration(canonical);
    if (!detected.matched) break;
    canonical = detected.title.replace(/\s+/g, " ").trim();
  }
  return canonical;
}

export function resolveTrackTitleDecoration(track = {}) {
  if (Object.prototype.hasOwnProperty.call(track, "titleDecoration")) return normalizeTitleDecoration(track.titleDecoration);
  return detectLegacyTitleDecoration(track.title).decoration;
}

export function displayTrackTitle(track = {}, fallback = "Untitled Beat") {
  const title = canonicalTrackTitle(track) || fallback;
  const decoration = resolveTrackTitleDecoration(track);
  if (!decoration.enabled) return title;
  return decoration.position === "after" ? `${title} ${decoration.icon}` : `${decoration.icon} ${title}`;
}

export function titleDecorationRegistryItem(icon) {
  return ALIAS_TO_ITEM.get(String(icon || "")) || null;
}
